import { useApi } from '@/api';
import {
  EntityName,
  KpiCard,
  Page,
  PageSkeleton,
  ActivityCard
} from '@/components';
import { CurrencyValue, Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricTabs from './HistoricTabs';

export default function LegacyRWAILKPage() {
  const { ilk } = useParams();
  const [data, error] = useApi({
    url: `/groups/legacy-rwa/ilks/${ilk}/`
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page
        title={
          <EntityName>
            <Flex gap="3xs" flexDirection="column">
              <Flex gap="3xs">
                <Heading size="1">{data.name}</Heading>
              </Flex>
              <Flex gap="3xs" color="muted">
                {data.ilk}
              </Flex>
            </Flex>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Debt"
            variant="dai"
            data={data}
            field="debt"
            options={{
              currency: 'DAI',
              valueOptions: {
                currencyValueOptions: {
                  variant: 'dynamic'
                }
              }
            }}
          />
          <KpiCard
            title="Debt Ceiling"
            data={data}
            field="line"
            options={{
              currency: '',
              valueOptions: {
                currencyValueOptions: {
                  variant: 'dynamic'
                }
              }
            }}
            footer={
              <Flex gap="3xs" alignItems="center">
                <span>Max:</span>
                <CurrencyValue value={data.dc_iam_line} variant="dynamic" />
              </Flex>
            }
          />
        </Flex>

        <HistoricTabs ilk={ilk} />

        <ActivityCard
          url={`/groups/legacy-rwa/ilks/${ilk}/activity/`}
          linkTo="activity"
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
